import { Button, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

export default function AddUserAPLLicense() {
  const intl = useIntl();
  const handleRepostFailedPosts = () => {
    axios
      .post(`${API_BASE_URL}/ShopNew/RePostFailedFortNoxOrders`)
      .then((response) => {
        toast.success(response.data.result);
      })
      .catch((err) => {
        toast.warn(formatServiceError(intl, err?.response?.data));
      });
  };

  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="OrderSection" />
          </h5>
        </Col>
      </Row>
      <Row>
        <Col className="mb-3">
          <Button
            color="primary"
            outline
            onClick={() => handleRepostFailedPosts()}
          >
            <FormattedMessage id="AplLicensesFailedRepost" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
